var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.09467 3.09467C4.42914 1.7602 6.42603 1.25 9 1.25H15C17.574 1.25 19.5709 1.7602 20.9053 3.09467C22.2398 4.42914 22.75 6.42603 22.75 9V15C22.75 17.574 22.2398 19.5709 20.9053 20.9053C19.5709 22.2398 17.574 22.75 15 22.75H9C6.42603 22.75 4.42914 22.2398 3.09467 20.9053C1.7602 19.5709 1.25 17.574 1.25 15V9C1.25 6.42603 1.7602 4.42914 3.09467 3.09467ZM4.15533 4.15533C3.2398 5.07086 2.75 6.57397 2.75 9V15C2.75 17.426 3.2398 18.9291 4.15533 19.8447C5.07086 20.7602 6.57397 21.25 9 21.25H15C17.426 21.25 18.9291 20.7602 19.8447 19.8447C20.7602 18.9291 21.25 17.426 21.25 15V9C21.25 6.57397 20.7602 5.07086 19.8447 4.15533C18.9291 3.2398 17.426 2.75 15 2.75H9C6.57397 2.75 5.07086 3.2398 4.15533 4.15533Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6.75C8.30964 6.75 7.75 7.30964 7.75 8C7.75 8.69036 8.30964 9.25 9 9.25C9.69036 9.25 10.25 8.69036 10.25 8C10.25 7.30964 9.69036 6.75 9 6.75ZM6.25 8C6.25 6.48122 7.48122 5.25 9 5.25C10.5188 5.25 11.75 6.48122 11.75 8C11.75 9.51878 10.5188 10.75 9 10.75C7.48122 10.75 6.25 9.51878 6.25 8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8813 13.0689C19.3824 12.6404 18.5376 12.6404 18.0387 13.0689L13.8787 16.6389C13.8786 16.639 13.8788 16.6389 13.8787 16.6389C12.8176 17.5501 11.1423 17.5503 10.0813 16.6389L10.0749 16.6334L9.74844 16.3465C9.30001 15.9638 8.53368 15.9168 8.01784 16.2628L3.08806 19.5727C2.74417 19.8036 2.27822 19.712 2.04733 19.3681C1.81644 19.0242 1.90804 18.5582 2.25194 18.3273L7.18194 15.0173C8.24502 14.3041 9.75679 14.3761 10.7288 15.2111L10.7351 15.2166L11.0615 15.5035C11.5608 15.9296 12.4033 15.9288 12.9013 15.5011L17.0613 11.9311C17.0612 11.9312 17.0614 11.931 17.0613 11.9311C18.1224 11.0199 19.7977 11.0197 20.8587 11.9311C20.8587 11.9311 20.8587 11.9311 20.8587 11.9311L22.4887 13.3311C22.8029 13.6009 22.8388 14.0745 22.5689 14.3887C22.2991 14.7029 21.8256 14.7388 21.5113 14.469L19.8813 13.0689Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMedia);
export default __webpack_public_path__ + "static/media/newMedia.902002db.svg";
export { ForwardRef as ReactComponent };